import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ExpirationsActions";

import { ScadenzaDto } from "../generated";
import DatesHelper from "../common/datesHelper";
import InterventiActions from "../interventi/InterventiActions";

class ExpirationsStore extends AbstractLookupStore<ScadenzaDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getExpirations, result => {
                this.set(this.getKey(result.from, result.to, result.showPrevYears), result.expirations!);
            })
            .onfunction(InterventiActions.add, result => {
                if (!result.idImpianto) return;
                for (let toChange of this.flatten().filter(x => x.idImpianto === result.idImpianto)) {
                    toChange.scheduledDateTime = result.dataIntervento;
                    toChange.idIntervento = result.idIntervento;
                }
                this.Changed.emit();
            })
            .onfunction(InterventiActions.update, result => {
                if (!result.idImpianto) return;
                for (let toChange of this.flatten().filter(x => x.idImpianto === result.idImpianto)) {
                    toChange.scheduledDateTime = result.dataIntervento;
                }
                this.Changed.emit();
            })
            .onfunction(InterventiActions.delete, result => {
                let { idIntervento, deleteOk } = result;
                if (!deleteOk) return;
                for (let toChange of this.flatten().filter(x => x.idIntervento === idIntervento)) {
                    toChange.scheduledDateTime = undefined;
                    toChange.idIntervento = undefined;
                }
                this.Changed.emit();
            })
            ;
    }

    getKey(from: Date, to: Date, showPrevYears: boolean) {
        return `${DatesHelper.getDateString(from)}-${DatesHelper.getDateString(to)}-${showPrevYears}`
    }
}

export default new ExpirationsStore()
